"use client";

import { useEffect } from "react";
import Image from "next/image";
import { ProductType } from "@/types/product.type";
import useRecentlyViewedProducts from "@/stores/recently-viewed-products";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

export default function Gallery({ product }: { product: ProductType }) {
  const { setProduct } = useRecentlyViewedProducts();

  useEffect(() => {
    setProduct(product);
  }, []);

  return (
    <div className="border border-zinc-200">
      <Swiper
        spaceBetween={12}
        slidesPerView={1}
        navigation
        modules={[Navigation, Pagination]}
        pagination={{ clickable: true }}
      >
        {product.images.map((image, index) => (
          <SwiperSlide key={index}>
            <Image
              width={800}
              height={800}
              src={image.original_url}
              alt={image.custom_properties.alt_text}
              className="w-full"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
